// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Campaign20 from './Campaign20.tsx';
import Campaign20Filled from './Campaign20Filled.tsx';
import Campaign20CircleFilled from './Campaign20CircleFilled.tsx';
import Campaign24 from './Campaign24.tsx';
import Campaign24Filled from './Campaign24Filled.tsx';
import Campaign24CircleFilled from './Campaign24CircleFilled.tsx';
import Campaign40 from './Campaign40.tsx';
import Campaign40Filled from './Campaign40Filled.tsx';
import Campaign48 from './Campaign48.tsx';
import Campaign48Filled from './Campaign48Filled.tsx';

type CampaignProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Campaign20,
    Campaign20Filled,
    Campaign20CircleFilled,
    Campaign24,
    Campaign24Filled,
    Campaign24CircleFilled,
    Campaign40,
    Campaign40Filled,
    Campaign48,
    Campaign48Filled,
};

const Campaign: FC<CampaignProps> = ({ variation, ...props }) => {
    const variationKey = `Campaign${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Campaign" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Campaign;
